import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { useClasses, createUseStyles, Icon, Text } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { errorToast } from 'utils/toast';
import { getEmailImageUploadingURL, uploadMedia } from 'lib/services/mailing';
import LottieGif from 'components/LottieGif';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const LOADING_LOTTIE =
    '{"nm":"Ã¥ÂÂÃ¦ÂÂ 1","ddd":0,"h":300,"w":300,"meta":{"g":"@lottiefiles/toolkit-js 0.33.2"},"layers":[{"ty":4,"nm":"Ã¥Â½Â¢Ã§ÂÂ¶Ã¥ÂÂ¾Ã¥Â±Â 2","sr":1,"st":0,"op":900,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[180,156.5,0],"t":0,"ti":[0,0,0],"to":[-13.3333330154419,0,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,156.5,0],"t":19,"ti":[-13.3333330154419,0,0],"to":[0,0,0]},{"s":[180,156.5,0],"t":40}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ã¦Â¤Â­Ã¥ÂÂ 1","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ã¦Â¤Â­Ã¥ÂÂÃ¨Â·Â¯Ã¥Â¾Â 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[40.916,40.916],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Ã¦ÂÂÃ¨Â¾Â¹ 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"c":{"a":0,"k":[1,1,1],"ix":3}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Ã¥Â¡Â«Ã¥ÂÂ 1","c":{"a":0,"k":[0.702,0.851,0.784],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[4.534,-3.114],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":1},{"ty":4,"nm":"Ã¥Â½Â¢Ã§ÂÂ¶Ã¥ÂÂ¾Ã¥Â±Â 1","sr":1,"st":0,"op":900,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,156.5,0],"t":0,"ti":[0,0,0],"to":[13.3333330154419,0,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[180,156.5,0],"t":19,"ti":[13.3333330154419,0,0],"to":[0,0,0]},{"s":[100,156.5,0],"t":40}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ã¦Â¤Â­Ã¥ÂÂ 1","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ã¦Â¤Â­Ã¥ÂÂÃ¨Â·Â¯Ã¥Â¾Â 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[40.916,40.916],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Ã¦ÂÂÃ¨Â¾Â¹ 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"c":{"a":0,"k":[1,1,1],"ix":3}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Ã¥Â¡Â«Ã¥ÂÂ 1","c":{"a":0,"k":[0,0.494,0.271],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[4.534,-3.114],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2}],"v":"4.10.1","fr":30,"op":41,"ip":0,"assets":[]}';

const useStyles = createUseStyles(styles, 'ImageComponent');

export default memo(({ node, updateAttributes, deleteNode, selected }) => {
    const { t } = useWeb5Context();
    const { file, src, alt, title, width, height } = node.attrs;
    const [virtualSize, setVirtualSize] = useState({ width, height });
    const [isLoading, setIsLoading] = useState(src ? false : true);
    const classes = useClasses(useStyles);
    const aspectRatio = useRef(width && height ? width / height : undefined);

    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [startY, setStartY] = useState(0);
    const [startWidth, setStartWidth] = useState(0);

    const getImageSizeFromBase64 = useCallback((base64Url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const originalWidth = img.width;
                const originalHeight = img.height;

                const maxWidth = 500;
                let width = originalWidth;
                let height = originalHeight;

                if (originalWidth > maxWidth) {
                    width = maxWidth;
                    height = (originalHeight * maxWidth) / originalWidth;
                }

                resolve({ width, height });
            };
            img.onerror = reject;
            img.src = base64Url;
        });
    }, []);

    const getImageSize = useCallback((file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                img.src = e.target.result;
            };

            reader.onerror = (e) => {
                console.error(e);
                reject();
            };

            img.onload = () => {
                const originalWidth = img.width;
                const originalHeight = img.height;

                const maxWidth = 500;
                let width = originalWidth;
                let height = originalHeight;

                if (originalWidth > maxWidth) {
                    width = maxWidth;
                    height = (originalHeight * maxWidth) / originalWidth;
                }

                resolve({ width, height });
            };

            reader.readAsDataURL(file);
        });
    }, []);

    const startResize = useCallback(
        (e) => {
            setIsResizing(true);
            setStartX(e.clientX);
            setStartY(e.clientY);
            setStartWidth(width);
            e.preventDefault();
        },
        [width],
    );

    const resize = useCallback(
        (e) => {
            if (isResizing) {
                const dx = e.clientX - startX;
                const dy = e.clientY - startY;

                const scaleFactor = 1 + (dx + dy) / 800;
                const newWidth = startWidth * scaleFactor;
                const newHeight = newWidth / aspectRatio.current;

                setVirtualSize({
                    width: newWidth,
                    height: newHeight,
                });

                e.preventDefault();
            }
        },
        [isResizing, startX, startY, startWidth],
    );

    const stopResize = useCallback(() => {
        if (!isResizing) return;
        setIsResizing(false);
        updateAttributes(virtualSize);
    }, [isResizing, updateAttributes, virtualSize]);

    useEffect(() => {
        if (!isLoading && !file && src) {
            // data base64 url
            getImageSizeFromBase64(src).then((size) => {
                aspectRatio.current = size.width / size.height;
                setVirtualSize({
                    width: size.width,
                    height: size.height,
                });
                updateAttributes({
                    width: size.width,
                    height: size.height,
                    src,
                });
            });
            return;
        } else if (!isLoading || !file) return;

        Promise.all([
            getImageSize(file),
            getEmailImageUploadingURL({
                name: file.name,
                size: file.size,
            }),
        ])
            .then(([size, uploadResponse]) =>
                uploadMedia(uploadResponse.data.url, file).then(() => ({
                    size,
                    data: uploadResponse.data,
                })),
            )
            .then(({ size, data }) => {
                aspectRatio.current = size.width / size.height;
                setVirtualSize({
                    width: size.width,
                    height: size.height,
                });
                updateAttributes({
                    width: size.width,
                    height: size.height,
                    src: data.link,
                });
            })
            .catch((e) => {
                console.error(e);
                errorToast({
                    t,
                    title: file.name,
                    text: t('label_error_uploading_image_desc'),
                });
                deleteNode();
            })
            .finally(() => setIsLoading(false));
    }, [
        deleteNode,
        file,
        getImageSize,
        getImageSizeFromBase64,
        isLoading,
        src,
        t,
        updateAttributes,
    ]);

    useEffect(() => {
        document.addEventListener('mousemove', resize);
        document.addEventListener('mouseup', stopResize);
        return () => {
            document.removeEventListener('mousemove', resize);
            document.removeEventListener('mouseup', stopResize);
        };
    }, [resize, stopResize]);

    useEffect(() => {
        if (selected) {
            setVirtualSize({ width, height });
        }
    }, [height, selected, width]);

    const showSelectedComp = src && selected;

    if (!file && !src) return null;

    return (
        <NodeViewWrapper
            data-drag-handle
            className={classnames(classes.root, {
                [classes.selected]: selected,
            })}
        >
            {showSelectedComp && (
                <div className={classes.resizers} style={virtualSize}>
                    <div className={classes.resizerTopLeft} onMouseDown={startResize}></div>
                    <div className={classes.resizerTopRight} onMouseDown={startResize}></div>
                    <div className={classes.resizerBottomLeft} onMouseDown={startResize}></div>
                    <div className={classes.resizerBottomRight} onMouseDown={startResize}></div>
                </div>
            )}
            {isLoading && (
                <div className={classes.loading}>
                    <Icon name="image" size="big" />
                    <LottieGif width="50px" height="50px" src={LOADING_LOTTIE} />
                </div>
            )}
            {src && <img src={src} alt={alt} title={title} width={width} height={height} />}
            {showSelectedComp && (
                <div className={classes.actions}>
                    <Text type="badges" onClick={deleteNode}>
                        {t('action_delete')}
                    </Text>
                </div>
            )}
        </NodeViewWrapper>
    );
});
